/** Labels and styling for serff_change_events rows (drawer / changelog). */

export const formatChangeEventType = (changeType) => {
  const t = String(changeType || '').toLowerCase();
  if (t.includes('objection')) return 'Objection issued';
  if (t.includes('status')) return 'Status changed';
  if (t.includes('document')) return 'Document added';
  if (t.includes('new') && t.includes('filing')) return 'New filing';
  if (t.includes('approved')) return 'Approved';
  if (t.includes('rejected')) return 'Rejected';
  if (t.includes('response')) return 'Response filed';
  if (!changeType) return 'Update';
  return changeType.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};

export const formatChangeEventDetail = (event) => {
  if (!event) return '—';
  if (event.notes) return event.notes;
  const t = String(event.change_type || '').toLowerCase();
  if (t.includes('status')) {
    if (event.old_value && event.new_value) {
      return `State status changed from ${event.old_value} to ${event.new_value}`;
    }
    return `State status changed to: ${event.new_value || '—'}`;
  }
  if (t.includes('document') && event.new_value) {
    return event.new_value;
  }
  if (t.includes('objection') && event.new_value) {
    return event.new_value;
  }
  if ((t.includes('new') || t.includes('filing')) && event.new_value) {
    return `First seen — ${event.new_value}`;
  }
  return event.new_value || event.old_value || '—';
};

export const changeEventDotClass = (changeType) => {
  const t = String(changeType || '').toLowerCase();
  if (t.includes('objection')) return 'ce-objection';
  if (t.includes('status')) return 'ce-status';
  return 'ce-new';
};
